module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6PnQ4"))).then(() => parcelRequire('dJXJK'));